<template>
	<footer>
	  <br class="d-none d-sm-block">
	  <div class="container py-4">
	    <div class="row">
	      <div class="col-sm-9 col-md-8 col-lg-5 col-xl-4">
	        <div class="media">
	          <img :src="require('@/assets/img/logo_pno.png')" class="mr-3 mt-1" alt="PNO Trailer Rental" width="41" height="37">
	          <div class="media-body">
	            <p>PNO Trailer Rental<br>
	              <small>{{ subTitle }}</small>
	            </p>
							<p>
								<a href="https://medium.com/pno-ventures" target="_blank" rel="nofollow"><i class="fab fa-lg fa-medium mr-2"></i></a>
								<a href="https://www.instagram.com/pnorental" target="_blank" rel="nofollow"><i class="fab fa-lg fa-instagram mr-2"></i></a>
								<a href="https://twitter.com/LeeOrnstrand" target="_blank" rel="nofollow"><i class="fab fa-lg fa-twitter mr-2"></i></a>
								<a href="https://www.linkedin.com/company/pno-group/" target="_blank" rel="nofollow"><i class="fab fa-lg fa-linkedin"></i></a>
							</p>
			        <hr class="d-md-none mt-4">
			        <p class="grey mb-0">
			          <small>
									© {{ new Date().getFullYear() }} PNO Holding A/S.<br>
									Build with <small class="red">♥</small> in Copenhagen by PNO Ventures.
								</small>
			        </p>
          	  <br class="d-md-none">
	          </div>
	        </div>
	      </div>
	      <div class="col-sm-3 col-md-4 col-lg-2 d-none d-sm-block text-sm-right text-lg-left">
					<ul class="list-unstyled">
						<li><small><a href="/compare">Rental vs. buying</a></small></li>
						<li><small><a href="/about">About us</a></small></li>
						<li><small><a href="https://pnorental.com/contact/">Contact</a></small></li>
						<li>
            	<small>
            		<a href="http://pnorental.com/wp-content/uploads/2018/07/Privacy-Policy.pdf" target="_blank" rel="nofollow">Privacy policy</a>
            	</small>
            </li>
          </ul>
				</div>
	      <div class="col-lg-2 col-xl-3 d-none d-lg-block">
					<ul class="list-unstyled">
            <li><small><a href="/trailer-rental/curtain-trailer-rental">Curtain Trailer Rental</a></small></li>
						<li><small><a href="/trailer-rental/reefer-trailer-rental">Reefer Trailer Rental</a></small></li>
						<li><small><a href="/trailer-rental/box-trailer-rental">Box Trailer Rental</a></small></li>
						<li><small><a href="/trailer-rental/dolly-trailer-rental">Dolly Trailer Rental</a></small></li>
					</ul>
				</div>
	      <div class="col-lg-3 d-none d-lg-block">
					<ul class="list-unstyled">
						<li><small><a href="/trailer-rental/moving-floor-trailer-rental">Moving Floor Trailer Rental</a></small></li>
						<li><small><a href="/trailer-rental/flatbed-trailer-rental">Flatbed Trailer Rental</a></small></li>
						<li><small><a href="/trailer-rental/container-chassis-trailer-rental">Container Chassis Trailer Rental</a></small></li>
						<li><small><a href="/trailer-rental">All Trailer Types for Rental</a></small></li>
					</ul>
				</div>
	    </div>
	  </div>
	  <br class="d-none d-sm-block">
	</footer>
</template>

<script>

import { countriesStr } from '@/assets/countries';

export default{
	name: 'PnoFooter',
	data() {
		return {
			subTitle: `Short-term Trailer Rental in ${countriesStr('and')}`,
		} 
	},
}

</script>